import Time from './times.vue';

Time.install = function (Vue) {
    Vue.component(Time.name, Time);
}

export default Time;


// WEBPACK FOOTER //
// ./src/components/times/index.js